import { Injectable } from '@angular/core';
import { Constants } from '../../../app.constants';
import { HttpRequestType } from '../../../core/request.service';
import { BaseService } from '../../../shared/base/base.service';

@Injectable({
  providedIn: 'root'
})

export class DocumentNumberingService extends BaseService {

  public getTypes(onSuccess: Function) {
    let url = `${Constants.contextPath}/document-numbering-configurations/types`;
    this.requestService.createRequest(HttpRequestType.Get, url, null, null, (response) => {
      onSuccess(response);
    })
  }
  
}